import { USER_ROLE } from "@/config/constants";

type RoleName = string;

export const ROLES: Record<string, RoleName[]> = {
  PARTICIPANT: [USER_ROLE.PARTICIPANT.NAME, USER_ROLE.SUB_PARTICIPANT.NAME],
  BRAND: [USER_ROLE.BRAND_OWNER.NAME, USER_ROLE.BRAND_USER.NAME],
  PARENT_COMPANY: [
    USER_ROLE.PARENT_COMPANY.NAME,
    USER_ROLE.PARENT_COMPANY_USER.NAME,
    USER_ROLE.PARENT_COMPANY_SUB_USER.NAME,
  ],
  PARTICIPANT_PARENT: [
    USER_ROLE.PARTICIPANT.NAME,
    USER_ROLE.SUB_PARTICIPANT.NAME,
    USER_ROLE.PARENT_COMPANY.NAME,
    USER_ROLE.PARENT_COMPANY_USER.NAME,
    USER_ROLE.PARENT_COMPANY_SUB_USER.NAME,
  ],
  ADMIN: [
    USER_ROLE.BRAND_OWNER.NAME,
    USER_ROLE.BRAND_USER.NAME,
    USER_ROLE.PARENT_COMPANY.NAME,
    USER_ROLE.PARENT_COMPANY_USER.NAME,
    USER_ROLE.PARENT_COMPANY_SUB_USER.NAME,
  ],
  ALL_AUTHENTICATED: [
    USER_ROLE.PARTICIPANT.NAME,
    USER_ROLE.SUB_PARTICIPANT.NAME,
    USER_ROLE.BRAND_OWNER.NAME,
    USER_ROLE.BRAND_USER.NAME,
    USER_ROLE.PARENT_COMPANY.NAME,
    USER_ROLE.PARENT_COMPANY_USER.NAME,
    USER_ROLE.PARENT_COMPANY_SUB_USER.NAME,
  ],
  PARTICIPANT_BRAND: [
    USER_ROLE.PARTICIPANT.NAME,
    USER_ROLE.SUB_PARTICIPANT.NAME,
    USER_ROLE.BRAND_OWNER.NAME,
    USER_ROLE.BRAND_USER.NAME,
  ],
  PAYMENT_RETURN: [
    USER_ROLE.BRAND_OWNER.NAME,
    USER_ROLE.BRAND_USER.NAME,
    USER_ROLE.PARENT_COMPANY.NAME,
    USER_ROLE.PARTICIPANT.NAME,
    USER_ROLE.SUB_PARTICIPANT.NAME,
    USER_ROLE.PARENT_COMPANY_USER.NAME,
    USER_ROLE.PARENT_COMPANY_SUB_USER.NAME,
  ],
  SUBSCRIPTION: [
    USER_ROLE.PARTICIPANT.NAME,
    USER_ROLE.SUB_PARTICIPANT.NAME,
    USER_ROLE.BRAND_USER.NAME,
    USER_ROLE.BRAND_OWNER.NAME,
    USER_ROLE.PARENT_COMPANY.NAME,
    USER_ROLE.PARENT_COMPANY_USER.NAME,
    USER_ROLE.PARENT_COMPANY_SUB_USER.NAME,
  ],
};
